<template lang="pug">
.login-form(:data-role='userRole')
  .login-form__title
    image-base.login-form__title__logo(:src='require("@/assets/img/common/logo.svg")')
    .login-form__title__text
      slot(name='loginTitle')
  text-frame.login-form__content
    .login-form__content__error.line-height-thin
      .login-form__content__error__message.text-xsmall(v-for='message in allErrorMessages') {{ message }}
    .login-form__content__input
      .login-form__content__input__label.text-small
        slot(name='accountCodeLabel')
      textbox-setting.login-form__content__input__textfield(v-model='accountCode')
    .login-form__content__input
      .login-form__content__input__label.text-small
        slot(name='passwordLabel')
      textbox-setting.login-form__content__input__textfield(type='password', v-model='password')
    button-login.login-form__content__button(@click='doLogin', :userRole='userRole')
      slot(name='loginButtonLabel')
  link-base.login-form__link(v-if='!isAdmin', @click='moveLinkEvent')
    slot(name='moveLinkText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import TextboxSetting from '@/components/molecules/manager/TextboxSetting.vue'
import ButtonLogin from '@/components/molecules/manager/ButtonLogin.vue'
import LinkBase from '@/components/atoms/LinkBase.vue'
import { UserRoles } from '@/const/UserRoles'
import { InputPatternSetting } from '@/const/DisplaySettings'

/**
 * 管理画面・ログイン画面（フォーム）
 */
@Component({
  components: {
    ImageBase,
    TextFrame,
    TextboxSetting,
    ButtonLogin,
    LinkBase,
  },
})
export default class LoginForm extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // ログインボタン押下時イベント
  @Prop()
  loginButtonEvent!: Function

  // 移動リンク押下時イベント（塾管理者画面、教室長・講師画面のみ）
  @Prop()
  moveLinkEvent?: Function

  // エラーメッセージ
  @Prop()
  errorMessages!: string[]

  // === 入力値を保持する変数群
  // ID
  public accountCode = ''
  // パスワード
  public password = ''

  // IDパターン不一致エラーメッセージ
  private patternErrorMessage = ''

  // システム管理者画面である
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  // 全てのエラーメッセージ
  private get allErrorMessages(): string[] {
    return this.errorMessages.concat([this.patternErrorMessage])
  }

  // ログイン実行
  private async doLogin() {
    this.patternErrorMessage = ''
    // IDのパターンに不一致の場合はエラーを返してログイン処理を行わない
    if (!this.accountCode.match(InputPatternSetting.ACCOUNT_PATTERN)) {
      this.patternErrorMessage = InputPatternSetting.ACCOUNT_PATTERN_ERROR_MESSAGE
      return
    }

    await this.loginButtonEvent()
  }
}
</script>

<style lang="stylus" scoped>
.login-form
  width 100%
  height 100%
  display flex
  flex-direction column
  justify-content center
  align-items center
  gap 32px
  background var(--background)

  &[data-role='admin']
    --background var(--color-manager-login__background-admin)
  &[data-role='academy']
    --background var(--color-manager-login__background-academy)
  &[data-role='branch']
    --background var(--color-manager-login__background-branch)

  &__title
    display flex
    flex-direction column
    align-items center
    gap 12px
    color var(--color-manager-login__text)

    &__logo
      width 85px

  &__content
    position relative
    width 374px
    display flex
    flex-direction column
    padding 50px 25px 25px 25px
    border-radius 20px
    gap 20px
    background var(--color-manager-login-frame__background)

    &__error
      position absolute
      top 20px
      left 25px
      width 324px
      height 25px
      overflow-y scroll

      &__message
        color var(--color-manager-login-alert__text)

    &__input
      display flex
      flex-direction column
      gap 5px

      &__textfield
        width 100%

  &__link
    color var(--color-manager-login__text)
</style>
